import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationLegalDocumentTemplateCategory = createCrudVuexModule({
  namespaced: true,
  path: "/legal-document-template-category",
});

export const organizationLegalDocumentTemplate = createCrudVuexModule({
  namespaced: true,
  path: "/legal-document-template",
  actions: {
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/legal-document-template/add-from-library", { libraryItemId: payload.libraryItem._id });
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async prepare({ commit }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/legal-document-template/prepare/${id}`);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationLegalDocument = createCrudVuexModule({
  namespaced: true,
  path: "/legal-document",
  state: { tab: "document" },
  getters: {
    tab: (state) => state.tab,
  },
  mutations: {
    tab: (state, value) => (state.tab = value),
  },
  actions: {
    async approve({ commit }, { id, fileCategoryId, fileNo, admin, isPeriodical, period }) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`/legal-document/approve/${id}/${fileCategoryId}/${fileNo}`, { admin, isPeriodical, period });
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
